import React from "react";
import { Helmet } from "react-helmet-async";

const getBaseUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return "https://sdro.in";
};

export const SEO = ({
  title = "SDRO — Scientific Development & Research Organisation",
  description = "SDRO is a carefully curated intellectual fellowship that mentors exceptional students in advanced astronomy, space science, and frontier space technologies. Access is strictly by invitation.",
  canonical,
  image = "https://customer-assets.emergentagent.com/job_1d6b5c61-8e78-4158-b22f-a4e0d0ebfc0c/artifacts/on9voaqw_App_icon.png",
  type = "website",
  path = "/",
}) => {
  const fullTitle = title.includes("SDRO") ? title : `${title} | SDRO`;
  const baseUrl = getBaseUrl();
  const canonicalUrl = canonical || `${baseUrl}${path}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
